const CHART_STYLE_KEY = 'portfolio_chart_style';
const DEFAULT_CHART_STYLE = 'line';

// The 6 series types TradingView Lightweight Charts ships (chart.addSeries(...)).
export const CHART_STYLES = [
  { id: 'line',        label: 'Line',        description: 'A single line through closing prices.' },
  { id: 'area',        label: 'Area',        description: 'Line chart with the area beneath it filled.' },
  { id: 'baseline',    label: 'Baseline',     description: 'Filled area above/below a baseline, colored by direction.' },
  { id: 'bar',         label: 'Bar',         description: 'OHLC bars — tick marks for open and close.' },
  { id: 'candlestick', label: 'Candlestick', description: 'OHLC candles — filled body between open and close.' },
  { id: 'histogram',   label: 'Histogram',   description: 'Vertical bars, one per price point.' },
];

export function getChartStyle() {
  const saved = localStorage.getItem(CHART_STYLE_KEY);
  return CHART_STYLES.some(s => s.id === saved) ? saved : DEFAULT_CHART_STYLE;
}

export function setChartStyle(style) {
  localStorage.setItem(CHART_STYLE_KEY, style);
}

const TRADE_MARKER_COLORS_KEY = 'portfolio_trade_marker_colors';
export const DEFAULT_TRADE_MARKER_COLOR = '#939598';

// Colors for the buy/sell transaction markers on the Charts page.
export function getTradeMarkerColors() {
  const defaults = { buy: DEFAULT_TRADE_MARKER_COLOR, sell: DEFAULT_TRADE_MARKER_COLOR };
  try {
    const saved = JSON.parse(localStorage.getItem(TRADE_MARKER_COLORS_KEY));
    const isColor = c => typeof c === 'string' && /^#[0-9a-f]{6}$/i.test(c);
    return {
      buy: isColor(saved?.buy) ? saved.buy : defaults.buy,
      sell: isColor(saved?.sell) ? saved.sell : defaults.sell,
    };
  } catch {
    return defaults;
  }
}

export function setTradeMarkerColors(colors) {
  localStorage.setItem(TRADE_MARKER_COLORS_KEY, JSON.stringify(colors));
}
